import TransactionDetail from '../../../../components/TransactionDetail';
import useTransactionState from '../../../../context/transaction/useTransactionState';

const PendingTransactions = () => {
    const { pendingTransactions } = useTransactionState();

    return (
        <div className='pending-transactions'>
            {pendingTransactions.length
                ? pendingTransactions.map((transaction, index) => (
                      <TransactionDetail key={index} transactionDetail={transaction} />
                  ))
                : null}
        </div>
    );
};

export default PendingTransactions;
